import { Link } from 'react-router-dom';

export default function HomeCTA() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg px-8 py-12 md:px-14 md:py-16">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">还没有收藏正确的访问地址？</h2>
          <p className="mt-3 text-background-50/80 text-sm md:text-base max-w-lg mx-auto">
            立即查看最新官方域名入口，避免钓鱼风险，确保安全访问鲍鱼平台
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/category/domain-entry" className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap">
              查看域名入口 <i className="ri-arrow-right-line"></i>
            </Link>
            <Link to="/about" className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap">
              了解更多 <i className="ri-information-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}